import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentPrioritiesComponent } from './document-priorities.component';
import { AddDocumentPrioritiesComponent } from './add-document-priorities/add-document-priorities.component';
import { EditDocumentPrioritiesComponent } from './edit-document-priorities/edit-document-priorities.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        DocumentPrioritiesComponent,
        AddDocumentPrioritiesComponent,
        EditDocumentPrioritiesComponent,
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [DocumentPrioritiesComponent],
})
export class DocumentPrioritiesModule { }
